export const TEMPLATE_BOOTSTRAP = {
  version: "2",
  lastUpdated: "2026-09-10T12:25:47.539Z",
  totalItems: 10255,
  items: [
    {
      id: "template-sentira",
      name: "Sentira",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/794b13f2-c2fb-43c2-aa24-1244e20e014c/01a0574e-2a99-705f-bfe6-4696619d0070.png",
      authorName: "Nasir Nawaz",
      authorUrl: "https://www.framer.com/marketplace/creator/nasir-nawaz/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/794b13f2-c2fb-43c2-aa24-1244e20e014c/4fvorgq4",
      featuredAt: null,
      categories: ["ai", "agency", "portfolio", "large-type", "modern", "minimal", "dark", "software", "style"],
      rank: 1,
      change: 0,
      trend: [100, 100, 100, 85, 69, 0, 0],
    },
    {
      id: "template-fabrica",
      name: "Fabrica",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/e77c8d2c-881f-46e7-b945-68aebec62cb0/j084yk2i",
      authorName: "Anatolii Dmitrienko",
      authorUrl: "https://www.framer.com/marketplace/creator/bynneh/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/31123/McHTH71f_400x400-VKlVpQryMU6V11WxN53SB2yWgeC2GY.jpg",
      featuredAt: null,
      categories: [
        "portfolio",
        "graphic-design",
        "large-type",
        "professional",
        "monochromatic",
        "animated",
        "minimal",
        "black-and-white",
        "creative",
        "style",
      ],
      rank: 2,
      change: 0,
      trend: [100, 100, 100, 75, 100, 0, 0],
    },
    {
      id: "template-gallary",
      name: "Gallary",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/8576eb45-a65a-403d-929d-3b4390a6e428/01a04372-137d-7369-b175-d38ab1d24662.png",
      authorName: "Anwar Raza",
      authorUrl: "https://www.framer.com/marketplace/creator/itsanwarraza/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/46166/avatar-0qtTvY5atCamiG19yf6Y5Qz5SLcGLn.jpg",
      featuredAt: null,
      categories: [
        "resume-cv",
        "personal",
        "photography",
        "portfolio",
        "art-and-design",
        "landing-page",
        "professional-services",
        "colorful",
        "creative",
        "business",
        "style",
      ],
      rank: 3,
      change: 23,
      trend: [76, 76, 76, 99, 100, 12, 0],
    },
    {
      id: "template-maestroclass",
      name: "MaestroClass",
      price: "58",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/60187/maestroclass-yxchECASfGF8Jsm8GvLLfpYV23FK3b",
      authorName: "Struxent",
      authorUrl: "https://www.framer.com/marketplace/creator/struxent/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/724226/avatar-hN9v3ElYtLqxBxFid09g20d5VQ4mQF.jpg",
      featuredAt: null,
      categories: [
        "food",
        "marketing",
        "landing-page",
        "education",
        "travel",
        "coaching",
        "animated",
        "pastel",
        "hospitality",
        "agency",
        "business",
        "professional-services",
        "health",
        "style",
      ],
      rank: 4,
      change: 0,
      trend: [100, 100, 100, 0, 0, 67, 67],
    },
    {
      id: "template-spector",
      name: "Spector",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/55318/spector-dZzr3mjyCLpn8HWhfhuGIsob69QpX9",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "professional-services",
        "large-type",
        "professional",
        "typographic",
        "modern",
        "animated",
        "style",
      ],
      rank: 5,
      change: 1,
      trend: [100, 100, 100, 0, 14, 29, 14],
    },
    {
      id: "template-neiden",
      name: "Neiden",
      price: "99",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/41a8b5fb-1df2-4e3b-9530-bb22de2ea48b/01a03ed6-f820-7639-9075-14fa44f343e6.jpg",
      authorName: "Førde",
      authorUrl: "https://www.framer.com/marketplace/creator/forde/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/41a8b5fb-1df2-4e3b-9530-bb22de2ea48b/ceg8qacx",
      featuredAt: null,
      categories: [
        "agency",
        "art-and-design",
        "landing-page",
        "graphic-design",
        "large-type",
        "animated",
        "colorful",
        "grid",
        "creative",
        "business",
        "style",
      ],
      rank: 6,
      change: -1,
      trend: [100, 100, 100, 8, 0, 4, 8],
    },
    {
      id: "template-tenora",
      name: "Tenora",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/300b3a94-48ea-4347-9758-5ab6ca2618ff/01a05782-94dd-73d5-91dd-8d0e48fe0c31.png",
      authorName: "N!nh™ Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/ninhstudio/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/300b3a94-48ea-4347-9758-5ab6ca2618ff/bginqadn",
      featuredAt: "2026-09-02T15:04:59.884Z",
      categories: [
        "ai",
        "technology",
        "conference",
        "community",
        "gradient",
        "animated",
        "3d",
        "colorful",
        "software",
        "business",
        "style",
      ],
      rank: 7,
      change: 91,
      trend: [100, 100, 100, 52, 43, 15, 0],
    },
    {
      id: "template-patrick-jane",
      name: "Patrick Jane",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/2bd867fa-1aea-4727-b79f-dba7ed862f40/01a06653-7444-74e8-9c47-125bb1b62856.png",
      authorName: "Avesh Mishra",
      authorUrl: "https://www.framer.com/marketplace/creator/aveshmishra/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/150434/avatar-U9OYU3PdCAuRevY9ThiNttq3DVWDxs.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "art-and-design",
        "artist",
        "landing-page",
        "film-and-actor",
        "modern",
        "dark",
        "creative",
        "business",
        "publishing",
        "entertainment",
        "style",
      ],
      rank: 8,
      change: 34,
      trend: [100, 100, 100, 41, 37, 6, 0],
    },
    {
      id: "template-arpeggio",
      name: "Arpeggio",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/48693/arpeggio-qRMShpuUYEGcVULUbvnU2MOUXmhQ1o",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "graphic-design",
        "large-type",
        "professional",
        "typographic",
        "modern",
        "animated",
        "creative",
        "style",
      ],
      rank: 9,
      change: 2,
      trend: [85, 86, 85, 100, 0, 0, 0],
    },
    {
      id: "template-salonix",
      name: "Salonix",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/794b13f2-c2fb-43c2-aa24-1244e20e014c/n2rwrtwm",
      authorName: "Nasir Nawaz",
      authorUrl: "https://www.framer.com/marketplace/creator/nasir-nawaz/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/794b13f2-c2fb-43c2-aa24-1244e20e014c/4fvorgq4",
      featuredAt: null,
      categories: ["health", "agency", "hair-and-beauty", "large-type", "style"],
      rank: 10,
      change: 56,
      trend: [83, 83, 83, 100, 97, 23, 0],
    },
    {
      id: "template-aldena",
      name: "Aldena",
      price: "99",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/2a2c2a43-045d-4da6-bf1a-ca4b52f39be1/01a0143a-d9f0-76d8-a65c-dc270aa06d62.png",
      authorName: "Lunis Design",
      authorUrl: "https://www.framer.com/marketplace/creator/lunis-design/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/480039/avatar-2unktHJIJ7qmZ6R3TmaJLIiOnmNlyk.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "marketing",
        "art-and-design",
        "graphic-design",
        "professional-services",
        "large-type",
        "typographic",
        "creative",
        "style",
      ],
      rank: 11,
      change: -2,
      trend: [0, 0, 0, 71, 71, 71, 100],
    },
    {
      id: "template-avyronpro",
      name: "Avyronpro",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/df0aeab2-687e-4760-b481-3d63c5122d53/01a049c5-338c-70a0-b9b7-62512be75099.png",
      authorName: "Modex Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/modex-studio/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/2120929/avatar-zGXyYaJMMobAPKa7srbDkukHhuiP81.jpg",
      featuredAt: null,
      categories: [
        "personal",
        "portfolio",
        "art-and-design",
        "graphic-design",
        "professional",
        "modern",
        "animated",
        "minimal",
        "creative",
        "style",
      ],
      rank: 12,
      change: 69,
      trend: [100, 100, 100, 80, 69, 19, 0],
    },
    {
      id: "template-nudge",
      name: "Nudge",
      price: "49",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/61898/nudge-wdAGEa9o4Syg6QuRvWUJOoY5zy7L9q",
      authorName: "Huehaus Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/huehaus-studio/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/34299/avatar-bp3mzKKtnuZkwx4x5jOPkcGyYw2xUX.jpg",
      featuredAt: null,
      categories: [
        "personal",
        "portfolio",
        "art-and-design",
        "illustrative",
        "large-type",
        "animated",
        "colorful",
        "grid",
        "creative",
        "style",
      ],
      rank: 13,
      change: 0,
      trend: [14, 14, 14, 100, 14, 0, 0],
    },
    {
      id: "template-nubo",
      name: "Nubo",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/3b062a58-ca05-4acc-91a2-b82e96bd3a5d/019f5f53-a9c6-745c-acc7-d66f9730bdc3.jpg",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: null,
      categories: [
        "startup",
        "saas",
        "marketing",
        "landing-page",
        "digital-products",
        "typographic",
        "light",
        "modern",
        "business",
        "technology",
        "software",
        "agency",
        "ecommerce",
        "style",
      ],
      rank: 14,
      change: 6,
      trend: [85, 85, 85, 96, 100, 1, 0],
    },
    {
      id: "template-majd",
      name: "Majd",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/62433/majd-QHkFMYYzoAFSLrXmOOVUZUNOkeFGiX",
      authorName: "Mejed Alkoutaini",
      authorUrl: "https://www.framer.com/marketplace/creator/mejed-alkoutaini/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28823/avatar-n6mh4YEcXV4xptbHhcU60cX7RCb5QA.jpg",
      featuredAt: null,
      categories: [
        "personal",
        "portfolio",
        "art-and-design",
        "professional-services",
        "professional",
        "modern",
        "animated",
        "3d",
        "creative",
        "style",
      ],
      rank: 15,
      change: 30,
      trend: [100, 100, 100, 0, 0, 2, 1],
    },
    {
      id: "template-creatie",
      name: "Creatie",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/4b8eacfd-b979-4bb5-942b-85860303ad92/019f9472-abbb-72a3-aee1-d4b5a53902ee.png",
      authorName: "Talha Nawaz",
      authorUrl: "https://www.framer.com/marketplace/creator/talha-uxd/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/745367/avatar-OpfMzB8yXp4YVO6sulGpIXL86P9Tyz.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "portfolio",
        "art-and-design",
        "artist",
        "digital-products",
        "professional",
        "colorful",
        "creative",
        "ecommerce",
        "style",
      ],
      rank: 16,
      change: 32,
      trend: [100, 100, 100, 0, 0, 2, 0],
    },
    {
      id: "template-fuel",
      name: "Fuel",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/58378/fuel-cxVfde7R2p54adU3CSTkTlNHUEwfXq",
      authorName: "Westhill Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/westhill-studio/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/29059/Dark%20logo-9sDWVbDyIvubCoiI69qjDKupxAVZGJ.png",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "portfolio",
        "landing-page",
        "light",
        "modern",
        "minimal",
        "business",
        "style",
      ],
      rank: 17,
      change: 37,
      trend: [100, 100, 100, 0, 0, 2, 0],
    },
    {
      id: "template-soren",
      name: "Soren",
      price: "149",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/52b07593-e9e2-457e-8a15-6b5c4b64bbc0/01a07fa3-841d-765f-bd54-9a64142e84d6.jpg",
      authorName: "Bryn Taylor",
      authorUrl: "https://www.framer.com/marketplace/creator/bryn-taylor/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28809/bryn-taylor-400-eHtZz9wnDGYajkJYqto5SgMs5gDnG2.jpg",
      featuredAt: "2026-09-02T15:04:59.884Z",
      categories: [
        "agency",
        "personal",
        "portfolio",
        "art-and-design",
        "landing-page",
        "professional",
        "modern",
        "minimal",
        "creative",
        "business",
        "style",
      ],
      rank: 18,
      change: 6,
      trend: [100, 100, 99, 3, 1, 1, 0],
    },
    {
      id: "template-kirk",
      name: "Kirk",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/65551/kirk-pjbtb3lUj21PNTHD036MQX7OX0f5nB",
      authorName: "Gustave Flowbert",
      authorUrl: "https://www.framer.com/marketplace/creator/gustave-flowbert/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28803/7ZJp9HSM8UYFPi6nrcwsXk3oYY-50mFsR5LLLFv5QWstXyzsBVkKH3woo.jpeg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "landing-page",
        "typographic",
        "modern",
        "minimal",
        "colorful",
        "business",
        "style",
      ],
      rank: 19,
      change: 39,
      trend: [100, 100, 100, 0, 0, 2, 0],
    },
    {
      id: "template-vertical",
      name: "Vertical",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/57417/vertical-jHUKj7Ubu1ETCuhg7EbPLvEKAKWpOf",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: "2026-09-02T15:04:59.884Z",
      categories: [
        "agency",
        "portfolio",
        "art-and-design",
        "large-type",
        "professional",
        "typographic",
        "modern",
        "animated",
        "creative",
        "style",
      ],
      rank: 20,
      change: -6,
      trend: [100, 100, 100, 0, 10, 15, 45],
    },
    {
      id: "template-portavia",
      name: "Portavia",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/51964/portavia-cHCplMO9DbnDQqYPVZXnAmlcltiTcB",
      authorName: "Duncan Shen",
      authorUrl: "https://www.framer.com/marketplace/creator/indesight/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/8991f28f-b668-4585-8916-758b0fcd0a67/ybf848vh",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "portfolio",
        "landing-page",
        "modern",
        "animated",
        "black-and-white",
        "3d",
        "business",
        "style",
      ],
      rank: 21,
      change: 39,
      trend: [100, 100, 100, 0, 0, 2, 0],
    },
    {
      id: "template-portfolite",
      name: "Portfolite",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/50716/portfolite-tSdwL2z7uMF6IBuGzhEUgbCmCKfrgt",
      authorName: "Pranav NB",
      authorUrl: "https://www.framer.com/marketplace/creator/pranavnb/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/7268d430-c7d2-47a1-8625-581faf2266ed/h2mt7zsg",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "portfolio",
        "landing-page",
        "monochromatic",
        "modern",
        "minimal",
        "3d",
        "business",
        "style",
      ],
      rank: 22,
      change: 39,
      trend: [100, 100, 100, 0, 0, 2, 0],
    },
    {
      id: "template-nordframe",
      name: "Nordframe®",
      price: "free",
      thumbnailUrl: "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/63372/nordframe",
      authorName: "Denysfs",
      authorUrl: "https://www.framer.com/marketplace/creator/denysfs/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/3ac5842b-c305-4095-9b31-5dbfbbc78000/vylkj34e",
      featuredAt: null,
      categories: [
        "personal",
        "photography",
        "portfolio",
        "art-and-design",
        "artist",
        "typographic",
        "minimal",
        "creative",
        "style",
      ],
      rank: 23,
      change: 60,
      trend: [73, 73, 73, 100, 99, 26, 0],
    },
    {
      id: "template-create",
      name: "Create",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/53318/create-snBP1lQGbExdj3bwfm0I3MOzlRS2is",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "landing-page",
        "large-type",
        "professional",
        "typographic",
        "modern",
        "animated",
        "business",
        "style",
      ],
      rank: 24,
      change: -6,
      trend: [40, 40, 40, 0, 40, 40, 100],
    },
    {
      id: "template-mondragon",
      name: "Mondragon",
      price: "39",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/6f1fa339-e254-4bb5-a7b0-7ca6bdd8815f/01a047d0-9f38-7489-8da3-520b4f95cc82.jpg",
      authorName: "Sabo Sugi – Mondragon Template",
      authorUrl: "https://www.framer.com/marketplace/creator/sabosugi/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/322027/avatar-gLNJKk2BH1oU6G2tRacFZWXlTUzSdJ.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "marketing",
        "art-and-design",
        "artist",
        "graphic-design",
        "dark",
        "creative",
        "style",
      ],
      rank: 25,
      change: 5,
      trend: [0, 0, 0, 43, 71, 100, 76],
    },
    {
      id: "template-miles",
      name: "Miles",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/6dc79884-b7e8-4fbf-9112-d942e9ce5fb8/01a088c5-02a0-7535-b631-3b9fffe40b95.png",
      authorName: "Muhammed Irshad",
      authorUrl: "https://www.framer.com/marketplace/creator/muhammed-irshad/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/30790/avatar-xYXMC0beZYIl0TvuYHWFXK33t6irqF.jpg",
      featuredAt: null,
      categories: ["agency", "personal", "portfolio", "modern", "animated", "minimal", "dark", "style"],
      rank: 26,
      change: 46,
      trend: [100, 100, 100, 0, 1, 3, 1],
    },
    {
      id: "template-rescale",
      name: "Rescale",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/48681/rescale-Ync68UYIHUmKT0kXQOZDfGowrxAytz",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "saas",
        "landing-page",
        "digital-products",
        "professional",
        "modern",
        "animated",
        "software",
        "business",
        "ecommerce",
        "style",
      ],
      rank: 27,
      change: -8,
      trend: [100, 100, 100, 88, 88, 0, 3],
    },
    {
      id: "template-owen-studio",
      name: "Owen Studio",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/771c68e5-95fd-4ffd-9875-dc3422984931/01a00f53-61f0-719a-a029-f477d41bdab5.png",
      authorName: "Kadir Calik",
      authorUrl: "https://www.framer.com/marketplace/creator/kadir/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/771c68e5-95fd-4ffd-9875-dc3422984931/z8pui3dc",
      featuredAt: null,
      categories: [
        "resume-cv",
        "agency",
        "personal",
        "photography",
        "blog",
        "portfolio",
        "art-and-design",
        "minimal",
        "creative",
        "style",
      ],
      rank: 28,
      change: 31,
      trend: [80, 80, 80, 100, 98, 14, 0],
    },
    {
      id: "template-tbd",
      name: "TBD",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/e77c8d2c-881f-46e7-b945-68aebec62cb0/01a05c57-cd38-75bf-a328-aec38a348ce1.jpg",
      authorName: "Anatolii Dmitrienko",
      authorUrl: "https://www.framer.com/marketplace/creator/bynneh/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/31123/McHTH71f_400x400-VKlVpQryMU6V11WxN53SB2yWgeC2GY.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "portfolio",
        "saas",
        "technology",
        "monochromatic",
        "animated",
        "black-and-white",
        "dark",
        "software",
        "business",
        "style",
      ],
      rank: 29,
      change: -4,
      trend: [100, 100, 100, 55, 41, 0, 9],
    },
    {
      id: "template-mono-x",
      name: "Mōno X",
      price: "99",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/5a8fe6df-024d-4c89-8b1a-570e37bcbe89/01a085ea-9130-773a-8fbc-4c1320ea89a7.png",
      authorName: "Deni from Flowmance",
      authorUrl: "https://www.framer.com/marketplace/creator/flowmance/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/29882/avatar-qxCHRoEJ7QcWuREHqfRiZqHCzTxL4S.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "agency",
        "portfolio",
        "modern",
        "animated",
        "black-and-white",
        "3d",
        "colorful",
        "software",
        "style",
      ],
      rank: 30,
      change: 13,
      trend: [69, 69, 69, 100, 56, 81, 0],
    },
    {
      id: "template-platform",
      name: "Platform",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/48558/platform-4YdRosaKHoKgNAI6l3cNvz3t9CFvUJ",
      authorName: "Tamas Bodo",
      authorUrl: "https://www.framer.com/marketplace/creator/tamas-bodo/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/834553/avatar-pOyurdbow2eub675g0t1S00I1a9ttk.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "saas",
        "landing-page",
        "professional",
        "typographic",
        "modern",
        "animated",
        "dark",
        "software",
        "business",
        "style",
      ],
      rank: 31,
      change: 2,
      trend: [100, 100, 100, 0, 17, 50, 17],
    },
    {
      id: "template-forth",
      name: "Forth",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/8445035a-a4ca-4abf-ae22-512cab628fcd/019fa345-f3c5-710f-9bd4-dc0ee4223851.jpg",
      authorName: "Hamza Ehsan",
      authorUrl: "https://www.framer.com/marketplace/creator/hamza-ehsan/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28849/avatar-Scx7VEk39n8Q8DzzI3O6aVK97JTdxu.jpg",
      featuredAt: null,
      categories: [
        "startup",
        "landing-page",
        "app",
        "social-and-recreational",
        "light",
        "modern",
        "animated",
        "colorful",
        "business",
        "technology",
        "community",
        "style",
      ],
      rank: 32,
      change: -4,
      trend: [72, 72, 72, 99, 100, 0, 2],
    },
    {
      id: "template-auton",
      name: "AUTON",
      price: "39",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/6aac6cfd-15f5-451e-beed-7051975f59a2/01a05c8d-1189-71ed-9c2b-cac387465aaa.jpg",
      authorName: "Shreetech",
      authorUrl: "https://www.framer.com/marketplace/creator/shreetech/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/6aac6cfd-15f5-451e-beed-7051975f59a2/to35xq1x",
      featuredAt: null,
      categories: [
        "resume-cv",
        "personal",
        "portfolio",
        "art-and-design",
        "professional",
        "modern",
        "animated",
        "3d",
        "creative",
        "style",
      ],
      rank: 33,
      change: -4,
      trend: [100, 100, 98, 0, 5, 12, 15],
    },
    {
      id: "template-zova",
      name: "Zova",
      price: "19",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/2a2c2a43-045d-4da6-bf1a-ca4b52f39be1/01a0146f-b036-70f9-82cd-58165fd3c60b.png",
      authorName: "Lunis Design",
      authorUrl: "https://www.framer.com/marketplace/creator/lunis-design/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/480039/avatar-2unktHJIJ7qmZ6R3TmaJLIiOnmNlyk.jpg",
      featuredAt: null,
      categories: [
        "saas",
        "landing-page",
        "professional-services",
        "light",
        "modern",
        "animated",
        "minimal",
        "software",
        "business",
        "style",
      ],
      rank: 34,
      change: -3,
      trend: [0, 0, 0, 36, 36, 79, 100],
    },
    {
      id: "template-makos",
      name: "MakOS",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/60415/makos-yxHkLR4rTEmuGVwtLxP5E2IfTjFJaO",
      authorName: "Immerse Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/immerse-studio/",
      creatorAvatarUrl: null,
      featuredAt: null,
      categories: [
        "personal",
        "portfolio",
        "personal-blog",
        "professional",
        "light",
        "modern",
        "minimal",
        "black-and-white",
        "creative",
        "blog",
        "style",
      ],
      rank: 35,
      change: 43,
      trend: [100, 100, 100, 0, 2, 3, 1],
    },
    {
      id: "template-agentlab",
      name: "AgentLab",
      price: "99",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/002fd15f-569c-45ed-870e-354988c9191a/01a0306e-3d55-7087-a179-0b57746b96ad.png",
      authorName: "Amani",
      authorUrl: "https://www.framer.com/marketplace/creator/helloamani/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/002fd15f-569c-45ed-870e-354988c9191a/dt0c0332",
      featuredAt: null,
      categories: [
        "ai",
        "startup",
        "saas",
        "landing-page",
        "technology",
        "professional-services",
        "light",
        "modern",
        "software",
        "business",
        "style",
      ],
      rank: 36,
      change: 10,
      trend: [0, 0, 0, 58, 100, 84, 32],
    },
    {
      id: "template-oberon",
      name: "Oberon®",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/ebaf78c9-2512-46d7-b33f-5cd3e97a4ed5/i81pndo8",
      authorName: "Tymofii Bak",
      authorUrl: "https://www.framer.com/marketplace/creator/tymofii-bak/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/47469/avatar-HJxvvd4WzTEBmm0ulo9nlRnXG4Z6AU.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "agency",
        "portfolio",
        "landing-page",
        "technology",
        "professional-services",
        "modern",
        "animated",
        "software",
        "business",
        "style",
      ],
      rank: 37,
      change: 0,
      trend: [0, 0, 0, 75, 92, 100, 100],
    },
    {
      id: "template-launchnow",
      name: "LaunchFolio",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/48356/launchnow-OC0qosljvjgCVQbSpJURDvrmGW0t2D",
      authorName: "Joseph Alexander",
      authorUrl: "https://www.framer.com/marketplace/creator/joseph-alexander/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/30929/avatarme-huNfMRLO8tm6y99B5JhCTp23eziKSs.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "portfolio",
        "art-and-design",
        "landing-page",
        "graphic-design",
        "professional",
        "animated",
        "creative",
        "business",
        "style",
      ],
      rank: 38,
      change: 46,
      trend: [100, 100, 100, 0, 3, 5, 1],
    },
    {
      id: "template-kora",
      name: "Kora",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/300f4c65-27a0-47d9-9b2d-d3e7324b37fb/n1z6ljfx",
      authorName: "Joseph Alexander",
      authorUrl: "https://www.framer.com/marketplace/creator/joseph-alexander/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/30929/avatarme-huNfMRLO8tm6y99B5JhCTp23eziKSs.jpg",
      featuredAt: "2026-09-02T15:04:59.884Z",
      categories: [
        "agency",
        "accounting",
        "consulting",
        "professional",
        "typographic",
        "modern",
        "animated",
        "colorful",
        "professional-services",
        "style",
      ],
      rank: 39,
      change: -3,
      trend: [100, 100, 100, 0, 0, 70, 100],
    },
    {
      id: "template-kai-marlow",
      name: "Kai Marlow",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/4a5b3c66-0cb4-4306-91d6-b4597a1e72ad/019fccf0-10bc-749f-9a29-9cb5785451b4.jpg",
      authorName: "Lazar Filipović",
      authorUrl: "https://www.framer.com/marketplace/creator/filipoviclazar/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/520346/avatar-ANsP3fSLOmFIU38OMCEygfZKqFPGpY.jpg",
      featuredAt: null,
      categories: [
        "photography",
        "art-and-design",
        "designers",
        "design",
        "black-and-white",
        "portfolio",
        "creative",
        "agency",
        "style",
      ],
      rank: 40,
      change: 47,
      trend: [100, 100, 100, 0, 6, 9, 2],
    },
    {
      id: "template-matchioo",
      name: "Matchioo",
      price: "25",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/afddff3d-f951-4c11-83d4-e21f34744ced/01a01399-e3f1-7271-9ea8-b3da3c039609.png",
      authorName: "Anugrah Babuji",
      authorUrl: "https://www.framer.com/marketplace/creator/anugrah-babuji/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/afddff3d-f951-4c11-83d4-e21f34744ced/4vhlsox1",
      featuredAt: null,
      categories: ["food", "bakery-and-cafe", "ecommerce", "animated", "hospitality", "style"],
      rank: 41,
      change: -7,
      trend: [0, 0, 0, 39, 61, 75, 100],
    },
    {
      id: "template-fitlex",
      name: "Fitlex",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/95ad4a3e-53f4-4780-9aa7-4eb5b20de6a9/01a04202-e640-741d-8668-4fc80e768ee6.jpg",
      authorName: "Galaxy Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/galaxy-studio/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/95ad4a3e-53f4-4780-9aa7-4eb5b20de6a9/fx94z9y4",
      featuredAt: null,
      categories: ["therapy", "health"],
      rank: 42,
      change: 269,
      trend: [100, 100, 100, 68, 69, 66, 0],
    },
    {
      id: "template-mattis",
      name: "Mattis",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/62149/mattis-4NskzhFtXZuzphsnrfo6jAMNWxeib5",
      authorName: "Anatolii Dmitrienko",
      authorUrl: "https://www.framer.com/marketplace/creator/bynneh/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/31123/McHTH71f_400x400-VKlVpQryMU6V11WxN53SB2yWgeC2GY.jpg",
      featuredAt: null,
      categories: [
        "portfolio",
        "graphic-design",
        "video",
        "professional",
        "animated",
        "minimal",
        "black-and-white",
        "grid",
        "creative",
        "publishing",
        "entertainment",
        "style",
      ],
      rank: 43,
      change: -4,
      trend: [14, 14, 14, 0, 14, 43, 100],
    },
    {
      id: "template-aoutive-website",
      name: "Aoutive Website",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/b2e693cc-f59c-4f8e-bde0-94300933232f/01a03d62-8b5f-778e-8d73-cd97a964a6d4.png",
      authorName: "Gr8r Themes",
      authorUrl:
        "https://www.framer.com/marketplace/creator/get-greater-quality-template-for-you-saas-ai-startup-business/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/29410/256px%20gr8r%20logo%20Orange-nLWk5qudXtDMsXR5C2wZI2mvFAiXwr.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "saas",
        "landing-page",
        "business-blog",
        "illustrative",
        "modern",
        "animated",
        "minimal",
        "software",
        "business",
        "creative",
        "blog",
        "style",
      ],
      rank: 44,
      change: 165,
      trend: [100, 100, 100, 74, 69, 51, 0],
    },
    {
      id: "template-artemis",
      name: "Artemis",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/52941/artemis-VYYdVJ1z16fdWOUIm4pLSixhcPS6fz",
      authorName: "Neueframe",
      authorUrl: "https://www.framer.com/marketplace/creator/neueframe/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/62918/avatar-5p1zId8TvEqaFObZGt8pghXsJfOeKH.jpg",
      featuredAt: null,
      categories: [
        "portfolio",
        "art-and-design",
        "artist",
        "professional",
        "light",
        "modern",
        "animated",
        "creative",
        "style",
      ],
      rank: 45,
      change: 44,
      trend: [100, 100, 100, 0, 4, 6, 2],
    },
    {
      id: "template-nolan-barret",
      name: "Nolan Barret",
      price: "29",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/52852/nolan-barret-BlGDsMMir4thWWh8dzh9hFOZwqXYd2",
      authorName: "ena supply",
      authorUrl: "https://www.framer.com/marketplace/creator/ena-supply/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28889/ena-logo-blue200-dkGvPFVf0tXicvAa8AXud0aOCVhKrh.jpg",
      featuredAt: null,
      categories: ["personal", "portfolio", "fashion", "minimal", "ecommerce", "style"],
      rank: 46,
      change: 3,
      trend: [50, 50, 50, 0, 75, 100, 75],
    },
    {
      id: "template-impact-flow",
      name: "Impact Flow",
      price: "39",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/efdb59bf-1cf5-40ab-aa7a-6ef399df96c6/019fa42a-eb0b-7657-a0e8-563d09ffb3f0.png",
      authorName: "Artificer Design Agency LLC",
      authorUrl: "https://www.framer.com/marketplace/creator/md-zahidul-hossain/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/899973/avatar-Dbk2PeZfOLb7ReibWF57IRwUKvuIcO.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "portfolio",
        "saas",
        "marketing",
        "typographic",
        "modern",
        "animated",
        "colorful",
        "software",
        "style",
      ],
      rank: 47,
      change: 3,
      trend: [0, 0, 0, 35, 82, 100, 82],
    },
    {
      id: "template-swiper",
      name: "Swiper",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/95eca361-5803-4211-9a29-a6095bcdbff3/019fb2fc-3e26-749f-970b-d2b72fbe77d2.jpg",
      authorName: "Stefan @ Pixco",
      authorUrl: "https://www.framer.com/marketplace/creator/stefcr/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/676311/rOT7i-PA5-cESJjLoqdEB1eUzuSTk6ZYVBVwn5YT",
      featuredAt: null,
      categories: [
        "startup",
        "saas",
        "landing-page",
        "accounting",
        "professional",
        "modern",
        "minimal",
        "dark",
        "business",
        "technology",
        "software",
        "professional-services",
        "style",
      ],
      rank: 48,
      change: 15,
      trend: [70, 70, 70, 96, 100, 8, 0],
    },
    {
      id: "template-dream-motion",
      name: "Dream Motion",
      price: "99",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/14c2826b-386e-4222-bcc8-33cf2acc0f74/019fe86d-c1e4-727d-b473-6252abcb5baf.png",
      authorName: "Dev Patel",
      authorUrl: "https://www.framer.com/marketplace/creator/devdsgn/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/14c2826b-386e-4222-bcc8-33cf2acc0f74/f4p9a442",
      featuredAt: null,
      categories: [
        "ai",
        "startup",
        "saas",
        "landing-page",
        "professional",
        "modern",
        "minimal",
        "dark",
        "software",
        "business",
        "technology",
        "style",
      ],
      rank: 49,
      change: -8,
      trend: [0, 0, 0, 62, 66, 83, 100],
    },
    {
      id: "template-geenie",
      name: "Geenie",
      price: "39",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/a8b5d8f7-8054-4428-9d13-1ff170b5cad3/01a06818-872e-731a-8cb1-85c139b917ec.png",
      authorName: "Jean",
      authorUrl: "https://www.framer.com/marketplace/creator/jean/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/a8b5d8f7-8054-4428-9d13-1ff170b5cad3/qgfvh25r",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "photography",
        "portfolio",
        "artist",
        "graphic-design",
        "modern",
        "minimal",
        "creative",
        "style",
      ],
      rank: 50,
      change: -3,
      trend: [100, 100, 100, 7, 7, 0, 7],
    },
    {
      id: "template-spartans",
      name: "Spartan's",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/61591/spartans-KdLJz0kl6cxGWUTxyhOMZ4YCxFsreN",
      authorName: "Delani.pro",
      authorUrl: "https://www.framer.com/marketplace/creator/delani/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28964/avatar-UVS0XgylW8W3x9F6Vm7lsdlmY90e1W.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "agency",
        "professional-services",
        "illustrative",
        "large-type",
        "modern",
        "minimal",
        "black-and-white",
        "software",
        "style",
      ],
      rank: 51,
      change: 0,
      trend: [0, 0, 0, 33, 63, 100, 100],
    },
    {
      id: "template-taylor",
      name: "Taylor",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/6e35a542-0c6e-4f5a-a79f-9c7544298ee3/9yxwf3p4",
      authorName: "Akin & Ed",
      authorUrl: "https://www.framer.com/marketplace/creator/akin-ed/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/6e35a542-0c6e-4f5a-a79f-9c7544298ee3/05raupra",
      featuredAt: null,
      categories: [
        "agency",
        "personal",
        "portfolio",
        "art-and-design",
        "landing-page",
        "graphic-design",
        "professional",
        "modern",
        "creative",
        "business",
        "style",
      ],
      rank: 52,
      change: 44,
      trend: [100, 100, 100, 0, 6, 9, 3],
    },
    {
      id: "template-riteora",
      name: "Riteora",
      price: "49",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/79ef3322-0abf-457f-9b5d-2734faf7f026/01a057a0-c71b-70ad-9c0e-833dce9cc6ae.png",
      authorName: "Jiaur R.",
      authorUrl: "https://www.framer.com/marketplace/creator/jibon/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/79ef3322-0abf-457f-9b5d-2734faf7f026/xbrx7alo",
      featuredAt: null,
      categories: [
        "food",
        "bar-and-club",
        "ecommerce",
        "food-blog",
        "community",
        "animated",
        "dark",
        "hospitality",
        "creative",
        "blog",
        "style",
      ],
      rank: 53,
      change: 9,
      trend: [100, 100, 100, 80, 0, 1, 0],
    },
    {
      id: "template-comingso-interactive",
      name: "ComingSo Interactive",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/56870ffa-753a-4f43-849a-921b07f4de48/01a03453-2bb8-722d-811b-04b3f48f770b.png",
      authorName: "Iconic Graphics",
      authorUrl: "https://www.framer.com/marketplace/creator/iconicgraphics/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/442362/avatar-5cAkrn6c4CT3LyepjCaxhrr3EOmftI.jpg",
      featuredAt: null,
      categories: [
        "agency",
        "photography",
        "art-and-design",
        "beauty",
        "ecommerce",
        "fashion",
        "interior-design",
        "animated",
        "portfolio",
        "creative",
        "style",
      ],
      rank: 54,
      change: 231,
      trend: [100, 100, 100, 68, 65, 61, 0],
    },
    {
      id: "template-strand",
      name: "Strand",
      price: "109",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/938b42d5-4518-4924-be18-128f9df69bc3/01a02955-b301-71d9-ab9b-d103dcca25d6.png",
      authorName: "Kreativnik",
      authorUrl: "https://www.framer.com/marketplace/creator/kreativnik/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/1211512/avatar-VO9m4gaeQiBP7V250qzpIfsWFUMlyE.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "startup",
        "saas",
        "technology",
        "digital-products",
        "animated",
        "3d",
        "dark",
        "software",
        "business",
        "ecommerce",
        "style",
      ],
      rank: 55,
      change: 1,
      trend: [100, 100, 100, 7, 60, 7, 0],
    },
    {
      id: "template-makro",
      name: "Makro",
      price: "129",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/57621/makro-LpT69cypoANUHkSidraOcCAFAbL06d",
      authorName: "Nick Stepuk",
      authorUrl: "https://www.framer.com/marketplace/creator/stfnco/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28844/avatar-vGg1AXeRJwvRbHUJn1XFc6L7RUvjT5.jpg",
      featuredAt: null,
      categories: [
        "ai",
        "web3",
        "startup",
        "saas",
        "landing-page",
        "technology",
        "accounting",
        "gradient",
        "software",
        "business",
        "professional-services",
        "style",
      ],
      rank: 56,
      change: -3,
      trend: [23, 23, 23, 0, 62, 77, 100],
    },
    {
      id: "template-perpetualx",
      name: "PerpetualX",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/63984/perpetualx-Yl8yaH0Zma41QED27YXl5nFVBso999",
      authorName: "Soleno Studio",
      authorUrl: "https://www.framer.com/marketplace/creator/soleno/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/43027/avatar-MVGgLqvLNYTlmzXqiB6NVBptetf0Tb.jpg",
      featuredAt: null,
      categories: [
        "startup",
        "saas",
        "landing-page",
        "gradient",
        "professional",
        "modern",
        "animated",
        "dark",
        "business",
        "technology",
        "software",
        "style",
      ],
      rank: 57,
      change: 70,
      trend: [66, 66, 66, 89, 100, 35, 0],
    },
    {
      id: "template-cohesion",
      name: "Cohesion",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/templates/45431/cohesion-uNEIatuYhYkmAxPbHHh5Q2HARjnv6H",
      authorName: "Cristian Mielu",
      authorUrl: "https://www.framer.com/marketplace/creator/cristian/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28883/avatar-K5ojCTv2bAJrkxuByVEiWGqgqe7d73.jpg",
      featuredAt: null,
      categories: ["agency", "personal", "portfolio", "light", "modern", "animated", "3d", "colorful", "style"],
      rank: 58,
      change: 36,
      trend: [0, 0, 0, 22, 62, 100, 61],
    },
    {
      id: "template-kima",
      name: "Kima",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/c311fc9b-5855-4020-b9a2-8710155f6d86/ckgk5zkd",
      authorName: "Thaer Swailem",
      authorUrl: "https://www.framer.com/marketplace/creator/thaer-swailem/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/28851/Frame%2048096971-7Wv7LVrAAopb22Ni22UXBYCA7AT3A5.png",
      featuredAt: null,
      categories: [
        "personal",
        "photography",
        "portfolio",
        "art-and-design",
        "graphic-design",
        "modern",
        "animated",
        "minimal",
        "creative",
        "style",
      ],
      rank: 59,
      change: -2,
      trend: [28, 28, 28, 91, 0, 97, 100],
    },
    {
      id: "template-kern",
      name: "Kern",
      price: "free",
      thumbnailUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/media/145266b7-4a55-4a3b-80a1-ecffbd4346ee/019f8c8b-b26b-708f-aade-1781d61b581b.jpg",
      authorName: "Aathif Thajudeen",
      authorUrl: "https://www.framer.com/marketplace/creator/aathif-thajudeen/",
      creatorAvatarUrl:
        "https://y4pdgnepgswqffpt.public.blob.vercel-storage.com/creators/1014411/avatar-3hhQ5xrvrHyPqcZW2PL4D8an7mFCGm.jpg",
      featuredAt: null,
      categories: [
        "personal",
        "portfolio",
        "professional-services",
        "light",
        "modern",
        "minimal",
        "black-and-white",
        "grid",
        "style",
      ],
      rank: 60,
      change: 7,
      trend: [66, 66, 66, 100, 92, 4, 0],
    },
  ],
};
